<!--
  First run: paste the API token.

  The token is not in the bundle. It is typed once and kept in IndexedDB, which
  is also where the service worker finds it when it drains the queue in the
  background.
-->
<script lang="ts">
  import { app } from '../lib/state.svelte';
  import { API_BASE, checkToken } from '../lib/api';

  let token = $state('');
  let busy = $state(false);
  let problem = $state<string | null>(null);

  async function submit(event: SubmitEvent) {
    event.preventDefault();
    if (!token.trim() || busy) return;
    busy = true;
    problem = null;

    const result = await checkToken(token);
    if (result === 'bad-token') {
      problem = 'The server did not accept that token.';
      busy = false;
      return;
    }
    if (result === 'offline') {
      problem = 'Saved, but the server could not be reached to check it.';
    }
    await app.pair(token);
    busy = false;
  }
</script>

<form class="pair" onsubmit={submit}>
  <h1>Lift</h1>
  <p class="muted">Paste the API token once. It stays on this phone.</p>

  <input
    type="password"
    bind:value={token}
    placeholder="API token"
    autocomplete="off"
    autocapitalize="off"
    spellcheck="false"
    aria-label="API token"
  />

  <button type="submit" disabled={busy || !token.trim()}>
    {busy ? 'Checking…' : 'Pair this phone'}
  </button>

  {#if problem}
    <p class="problem">{problem}</p>
  {/if}

  <p class="api">{API_BASE || 'same origin'}</p>
</form>

<style>
  .pair {
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 14px;
    padding: 24px;
  }

  h1 {
    font-size: 1.1rem;
    font-weight: 600;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--dim);
    margin: 0;
  }

  .muted {
    color: var(--dim);
    margin: 0;
  }

  input {
    background: var(--panel);
    border: 1px solid var(--line);
    border-radius: 12px;
    color: var(--text);
    font-size: 1rem;
    padding: 16px;
  }

  button {
    background: var(--accent);
    border: 0;
    border-radius: 12px;
    color: var(--on-accent);
    font-size: 1.05rem;
    font-weight: 600;
    min-height: 60px;
  }

  button:disabled {
    opacity: 0.5;
  }

  .problem {
    color: var(--warn-text);
    font-size: 0.9rem;
    margin: 0;
  }

  .api {
    color: var(--faint);
    font-size: 0.75rem;
    margin: 0;
    text-align: center;
  }
</style>
